const UNSAFE_CHARACTERS = /[\u0000-\u001F\u007F\\]/;
const SCHEME_PREFIX = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;
const MAX_DECODE_ROUNDS = 10;

function isSameOriginHttpUrl(url: URL, origin: string): boolean {
  return (
    url.origin === origin &&
    (url.protocol === "http:" || url.protocol === "https:")
  );
}

function isSafeRelativeRedirect(location: string, origin: string): boolean {
  if (location.length === 0) {
    return false;
  }

  if (UNSAFE_CHARACTERS.test(location)) {
    return false;
  }

  if (!location.startsWith("/") || location.startsWith("//")) {
    return false;
  }

  try {
    return isSameOriginHttpUrl(new URL(location, origin), origin);
  } catch {
    return false;
  }
}

function hasUnsafeEncodedRedirect(location: string): boolean {
  let current = location;

  for (let round = 0; round < MAX_DECODE_ROUNDS; round++) {
    let decoded: string;
    try {
      decoded = decodeURIComponent(current);
    } catch {
      return true;
    }

    if (decoded === current) {
      return false;
    }

    if (decoded.startsWith("//") || SCHEME_PREFIX.test(decoded)) {
      return true;
    }

    current = decoded;
  }

  return true;
}

export function isSafeRedirectUrl(
  location: string,
  origin: string = globalThis.location.origin,
): boolean {
  return (
    isSafeRelativeRedirect(location, origin) &&
    !hasUnsafeEncodedRedirect(location)
  );
}
